import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';

const HydraTrackProduct = () => {
  return (
    <div>
      <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Products</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
            <li className="breadcrumb-item"><a href="#">HydraTrack – Distribution Management Platform</a></li>
            <li className="breadcrumb-item active text-primary">Hydra Track</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Project Overview Section */}
      <section className="bg-yellow-light p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src="/products/dashboard.png"
                    className="img-fluid rounded"
                    alt="HydraTrack Order & Delivery Management System"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Order & Delivery Management System</h1>
              <p className="font-size-p">
                This is a full-stack order and delivery tracking system designed to streamline water distribution
                operations across multiple roles including customers, logistics partners, admins, and regional
                managers. The platform centralizes ordering, delivery proof capture, monitoring, and reporting into
                a single scalable system.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Project Overview End */}

      {/* Problem Statement Section */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Problem Statement</h1>
              <p className="font-size-p">
                Traditional distribution businesses rely heavily on manual processes, spreadsheets, and unverified
                deliveries. This leads to lack of transparency, delivery disputes, poor coordination, and inefficient
                tracking. The system digitizes and structures the entire order-to-delivery workflow.
              </p>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src="/products/customers.png"
                    className="img-fluid rounded"
                    alt="Distribution Management Solution"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Problem Statement End */}

      {/* Key Features Section */}
      <section className="bg-light p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src="/products/products.png"
                    className="img-fluid rounded"
                    alt="Key Features"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Key Features</h1>
              <ul className="list-unstyled">
                <li><span className="icon-box"></span> Role-based dashboards (Customer, Logistic, Admin, Customer Admin, City Lead, Super Distributor, Developer)</li>
                <li><span className="icon-box"></span> Daily order placement and order history tracking</li>
                <li><span className="icon-box"></span> Delivery proof upload (photos, signature, GPS coordinates)</li>
                <li><span className="icon-box"></span> OTP-based delivery verification using push notifications</li>
                <li><span className="icon-box"></span> Admin monitoring with filtering, editing, and bulk cancellation</li>
                <li><span className="icon-box"></span> Excel bulk order upload with validation (all-or-nothing logic)</li>
                <li><span className="icon-box"></span> CSV and pivot exports for reporting</li>
                <li><span className="icon-box"></span> Support ticket system with attachment support</li>
                <li><span className="icon-box"></span> Test case PDF library with customer mapping</li>
                <li><span className="icon-box"></span> WhatsApp notifications and Firebase push notifications</li>
                <li><span className="icon-box"></span> Daily automated delivered orders email report (cron job)</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Key Features End */}

      {/* System Architecture Section */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 p-5">
              <h1>System Architecture</h1>
              <p className="font-size-p mb-3">
                <strong>Frontend:</strong> React (Vite) with role-based routing and protected authentication.
              </p>
              <p className="font-size-p mb-3">
                <strong>Backend:</strong> Node.js and Express REST API with role-based access control.
              </p>
              <p className="font-size-p mb-3">
                <strong>Database:</strong> MongoDB with structured collections for users, orders, tickets, test cases, and uploaded files.
              </p>
              <p className="font-size-p mb-3">
                <strong>Cloud & Integrations:</strong> AWS S3 for file storage, Firebase Cloud Messaging for push notifications,
                WhatsApp messaging integration, and scheduled email reports using cron jobs.
              </p>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src="/products/manageusers.png"
                    className="img-fluid rounded"
                    alt="System Architecture"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* System Architecture End */}

      {/* Core Workflows Section */}
      <section className="bg-light p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src="/products/orderhistory.png"
                    className="img-fluid rounded"
                    alt="Core Workflows"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Core Workflows</h1>
              <ul className="list-unstyled">
                <li><span className="icon-box"></span> <strong>Login Flow:</strong> Authentication via API with role-based dashboard routing.</li>
                <li><span className="icon-box"></span> <strong>Order Placement:</strong> Customer places order → Stored in MongoDB → Optional WhatsApp notification sent.</li>
                <li><span className="icon-box"></span> <strong>Delivery Completion:</strong> Logistic uploads proof → Files stored in S3 → Order marked delivered → Ticket auto-resolution.</li>
                <li><span className="icon-box"></span> <strong>Admin Oversight:</strong> Filter/search orders → Edit/cancel → Export reports.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Core Workflows End */}

      {/* Security & Controls Section */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Security & Controls</h1>
              <ul className="list-unstyled">
                <li><span className="icon-box"></span> Role-based access control</li>
                <li><span className="icon-box"></span> Global access key validation for non-developer roles</li>
                <li><span className="icon-box"></span> Secure cloud file storage</li>
                <li><span className="icon-box"></span> OTP verification for delivery confirmation</li>
                <li><span className="icon-box"></span> Token-based push notification handling</li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src="/products/tickets.png"
                    className="img-fluid rounded"
                    alt="Security & Controls"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Security & Controls End */}

      {/* Business Impact Section */}
      <section className="bg-light p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src="/products/testreports.png"
                    className="img-fluid rounded"
                    alt="Business Impact"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Business Impact</h1>
              <p className="font-size-p">
                The system improves operational transparency, reduces manual errors, enables verified
                proof-based deliveries, and supports scalable regional distribution management. It transforms
                traditional distribution workflows into a structured, digital, and automated ecosystem.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Business Impact End */}

      <Footer/>
    </div>
  );
};

export default HydraTrackProduct;

